module.exports = __webpack_public_path__ + "img/bamboohr-logo-green.5be63275.svg";